import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogEspecial } from '../confirmation-dialog/confirmation-dialog-especial.component';
import Swal from 'sweetalert2';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { AppComponent } from 'src/app/app.component';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
    selector: 'app-afiliacion',
    templateUrl: '../../pages/afiliacion/afiliacion.component.html',
    styleUrls: ['../../pages/afiliacion/afiliacion.component.css']
})
export class AfiliacionComponent implements OnInit {

    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    emailPattern:string = "/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/";
    rut: any;
    isAdmin: boolean;
    nombres: any;
    accion:any;
    entidad:any;
    diasDiferencia: any;
    bancos: any;
    regiones: any
    comunas: any
    nacionalidades: any
    tiposPensiones: any  
    entidadesPensiones: any  
    modalidadesPensiones: any  
    tipoCuentas: any;
    estadoCivil: any;
    sistemaSalud: any;
    data: any = { rutAfiliado: "", calidadJuridicaCodigo: 0, nombres: "", idAfiliado: "", email: "", fechaActual: "", scales: false }
   
    @Input() afiliado: Afiliado;

    constructor(private router: Router,
        private afiliacionService: AfiliacionService,
        private mantenedorUsuarioService: MantenedorUsuariosService,
        private appComponent: AppComponent,
        private dialog: MatDialog) {  
            let vm = this
            vm.isAdmin =false 
        }

    ngOnInit(): void {
        let vm = this
        vm.isAdmin =false
      
        if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
        {
            this.appComponent.logoutJubilado();
        }
        if(vm.rol=='ROLE_ADMINISTRADOR'){
            vm.isAdmin =true
        }
        vm.afiliado = new Afiliado();

        if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {

            vm.afiliado.rut=localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");

            this.buscar(false)
        }


        this.afiliacionService.traeBancos().then
            (bancos => {
                vm.bancos = bancos
                vm.afiliado.bancos = vm.bancos
            })

        this.afiliacionService.traeTipoCuentas().then
            (tipoCuentas => {
                vm.tipoCuentas = tipoCuentas
                vm.afiliado.tipoCuentas = vm.tipoCuentas
            })

        this.afiliacionService.traeNacionalidades().then
            (nacionalidades => {
                vm.nacionalidades = nacionalidades
                vm.afiliado.nacionalidades = vm.nacionalidades
            })
        this.afiliacionService.getTipoPension().then
            (tiposPensiones => {
                vm.tiposPensiones = tiposPensiones
                vm.afiliado.tiposPensiones = vm.tiposPensiones
            })

        this.afiliacionService.getEntidadPension().then
        (entidadesPensiones => {
            vm.entidadesPensiones = entidadesPensiones
            vm.afiliado.entidadesPensiones = vm.entidadesPensiones
        }) 
        
        this.afiliacionService.getModalidadPension().then
        (modalidadesPensiones => {
            vm.modalidadesPensiones = modalidadesPensiones
            vm.afiliado.modalidadesPensiones = vm.modalidadesPensiones
        }) 

        this.mantenedorUsuarioService.traeRegiones().then
            (regiones => { vm.afiliado.regiones = regiones })

        this.afiliacionService.traeEstadoCivil().then
        (estadoCivil => {
            vm.estadoCivil = estadoCivil
            vm.afiliado.estadoCivil = vm.estadoCivil
        })

        this.afiliacionService.traeSistemaSalud().then
        (sistemaSalud => {
            vm.sistemaSalud = sistemaSalud
            vm.afiliado.sistemaSalud = vm.sistemaSalud
        })
            
            
    }


    actualizar(actualizadoGesdep: boolean) {
        let vm = this
        if (!vm.afiliado.rut) {
            this.openAlertDialog('Se puede actualizar un afiliado luego de ser buscado', 'btn-danger')
            return false
        }

        if (Rut(this.afiliado.rut)) {

            const dialogRef = this.dialog.open(ConfirmationDialog,
                {
                    data: { message: '¿Estás seguro de actualizar el afiliado con Gesdep?', buttonText: { ok: 'Si', cancel: 'No' } }
                })
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        icon: 'info',
                        text: 'Cargando...'
                    });
                    Swal.showLoading();
                    this.afiliacionService.actualizaAfiliadoDesdeGesdep(this.afiliado.rut).then
                        (
                            response => {
                                this.buscar(true, actualizadoGesdep,'Se ha actualizado correctamente el afiliado.')
                            }
                        )
                        .catch
                        (
                            () => {
                                vm.openAlertDialog('Ha surgido un error en la actualización.', 'btn-danger')
                            }
                        )
                }
            })

        } else {
            this.openAlertDialog('El RUT del usuario es incorrecto. Favor Revisar', 'btn-danger')
        }
    }

   
    buscar(recarga?: boolean, actualizadoGesdep?: boolean, mensaje?: string) {
        let vm = this
        let data: any = {}
        vm.accion="agregar" 
        vm.entidad="buscar" 
        if (!recarga) {
            Swal.fire({
                allowOutsideClick: false,
                icon: 'info',
                text: 'Cargando...'
            });
            Swal.showLoading();
        }
        if (!vm.afiliado.rut.includes('-')) {
            Swal.close();
            this.openAlertDialog('Debe ingresar el campo rut con guión.', 'btn-dark')
            return false
        }

        if (vm.afiliado.rut && !Rut(vm.afiliado.rut)) {
            Swal.close();
            this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
            return false    
        }

        if (vm.afiliado.rut != "" && vm.afiliado.rut.split('-')[0] != "") {
            this.afiliacionService.traeSoloAfiliadoSinEstados(vm.afiliado.rut.split('-')[0]).then
                (
                    (response: any) => {
                        if (response == null) {
                            Swal.close();
                            vm.openAlertDialog('No se ha encontrado el afiliado buscado.', 'btn-dark');
                            this.limpiarData() 
                        } else {
                            this.actualizarData(response)
                            this.mantenedorUsuarioService.traeComunas(response.direccion.idRegion).then
                                (comunas => vm.afiliado.comunas = comunas)
                            if (recarga) {
                               
                                if (!actualizadoGesdep) {
                                    vm.openAlertDialog(mensaje, 'btn-success')
                                } else {
                                    vm.openAlertDialog('Solicitud enviada exitosamente, una ejecutiva revisará los antecedentes y se le comunicará por correo electrónico el estado de esta.', 'btn-success')
                                }
                            }
                            Swal.close();
                        }
                    }
                )
                .catch(error => {
                    console.log(error.status)
                    if (error.status == 404 || error.status == 500) {
                        if(vm.isAdmin){
                            const dialogRef = this.dialog.open(ConfirmationDialogEspecial, {
                                data: {
                                    message: 'RUT no se encuentra Afiliado al Servicio de Bienestar. ¿Desea Afiliar?',
                                    botonStyleCancel:"margin-left:20%;",
                                    botonStyleAceptar:"margin-left:20%;",
                                    buttonText: { ok: 'Si', cancel: 'No' }
                                }
                            });
    
                            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                                if (confirmed && vm.isAdmin) {    
                                    this.buscarDesdeGesdep(vm.afiliado.rut);    
                                } else {
                                    this.limpiarData()
                                }
                            });
                            Swal.close();
                        }else{
                            this.limpiarData() 
                            vm.openAlertDialog('RUT no se encuentra Afiliado al Servicio de Bienestar', 'btn-success')
                            Swal.close();
                        }
                        
                    }
                    Swal.close();
                })


        } else {
            this.limpiarData() 
            this.afiliado = this.afiliado
            Swal.close();
        }


    }

    actualizarData(response: any) {
        let vm = this
        try {
            vm.afiliado.id = response.id
            vm.afiliado.rut = response.rut + '-' + response.dv
            vm.afiliado.email = response.email
            vm.afiliado.emailPersonal = response.emailPersonal
            vm.afiliado.nombres = response.nombres
            vm.afiliado.apellidoPaterno = response.apellidoPaterno
            vm.afiliado.apellidoMaterno = response.apellidoMaterno
            vm.afiliado.idSexo = response.idSexo
            vm.afiliado.idNacionalidad = response.idNacionalidad
            vm.afiliado.tipoAfiliado = response.tipoAfiliado.toUpperCase();
           
            if (response.fechaAfiliacion) {
                vm.afiliado.fechaAfiliacion = response.fechaAfiliacion.split('-').length > 0 ?
                    response.fechaAfiliacion.split('-')[2] + '-' + response.fechaAfiliacion.split('-')[1] + '-' + response.fechaAfiliacion.split('-')[0] : ''
            } else {
                response.fechaAfiliacion = []
                vm.afiliado.fechaAfiliacion =''
            }

            if (response.fechaDesafiliacion) {
                vm.afiliado.fechaDesafiliacion = response.fechaDesafiliacion.split('-').length > 0 ?
                    response.fechaDesafiliacion.split('-')[2] + '-' + response.fechaDesafiliacion.split('-')[1] + '-' + response.fechaDesafiliacion.split('-')[0] : ''
            } else {
                response.fechaDesafiliacion = []
                vm.afiliado.fechaDesafiliacion =''
            }

            if (response.fechaNacimiento) {
                vm.afiliado.fechaNacimiento = response.fechaNacimiento.split('-').length > 0 ?
                    response.fechaNacimiento.split('-')[2] + '-' + response.fechaNacimiento.split('-')[1] + '-' + response.fechaNacimiento.split('-')[0] : ''
            } else {
                response.fechaNacimiento = []
                vm.afiliado.fechaNacimiento =[]
            }
            if (response.datosLaborales) {
                vm.afiliado.grado = response.datosLaborales.grado
                vm.afiliado.parentesco = response.datosLaborales.parentesco
                vm.afiliado.calidadJuridica = response.datosLaborales.calidadJuridica
                vm.afiliado.asociadoA = response.datosLaborales.asociadoA
                vm.afiliado.funcionRealizada = response.datosLaborales.funcionRealizada
                vm.afiliado.estamento = response.datosLaborales.estamento
                vm.afiliado.programaPresupuestario = response.datosLaborales.programaPresupuestario
                vm.afiliado.grado = response.datosLaborales.grado
                vm.afiliado.numResolucion = response.datosLaborales.numResolucion

                if (response.datosLaborales.fechaCalidadJuridica) {
                    let fechaCalidadJuridica = response.datosLaborales.fechaCalidadJuridica.split('-')
                    vm.afiliado.fechaCalidadJuridica = fechaCalidadJuridica[2] + '-' + fechaCalidadJuridica[1] + '-' + fechaCalidadJuridica[0]
                } else {
                    vm.afiliado.fechaCalidadJuridica = []
                }
                if (response.datosLaborales.fechaInicioGrado) {
                    let fechaInicioGrado = response.datosLaborales.fechaInicioGrado.split('-')
                    vm.afiliado.fechaInicioGrado = fechaInicioGrado[2] + '-' + fechaInicioGrado[1] + '-' + fechaInicioGrado[0]
                } else {
                    vm.afiliado.fechaInicioGrado = []
                }
                if (response.datosLaborales.fechaResolucion) {
                    let fechaResolucion = response.datosLaborales.fechaResolucion.split('-')
                    vm.afiliado.fechaResolucion = fechaResolucion[2] + '-' + fechaResolucion[1] + '-' + fechaResolucion[0]
                } else {
                    vm.afiliado.fechaResolucion = []
                }
                if (response.datosLaborales.fechaCargo) {
                    let fechaCargo = response.datosLaborales.fechaCargo.split('-')
                    vm.afiliado.fechaCargo = fechaCargo[2] + '-' + fechaCargo[1] + '-' + fechaCargo[0]
                } else {
                    vm.afiliado.fechaCargo = []
                }
            }else{
                vm.afiliado.grado =''
                vm.afiliado.parentesco =''
                vm.afiliado.calidadJuridica =''
                vm.afiliado.asociadoA =''
                vm.afiliado.funcionRealizada = ''
                vm.afiliado.estamento =''
                vm.afiliado.fechaCalidadJuridica = []
                vm.afiliado.programaPresupuestario =''
                vm.afiliado.grado =''
                vm.afiliado.numResolucion = ''
                vm.afiliado.fechaInicioGrado = []
                vm.afiliado.fechaResolucion = []
                vm.afiliado.fechaCargo = []
            }

            if (response.datosBancarios) {
                vm.afiliado.bancoCodigo = response.datosBancarios.idBanco
                vm.afiliado.tipoCuentaCodigo = response.datosBancarios.idTipoCuenta
                vm.afiliado.numeroCuenta = response.datosBancarios.numeroCuenta
            } else {
                vm.afiliado.bancoCodigo = ''
                vm.afiliado.tipoCuentaCodigo = ''
                vm.afiliado.numeroCuenta = ''
            }
        
            if (response.datosPensiones) {
                vm.afiliado.montoPension = response.datosPensiones.montoPension
                vm.afiliado.tipoPension = response.datosPensiones.tipoPension
                vm.afiliado.entidadPension = response.datosPensiones.entidadPension
                vm.afiliado.modalidadPension = response.datosPensiones.modalidadPension
            } else {
                vm.afiliado.montoPension = ''
                vm.afiliado.tipoPension = ''
                vm.afiliado.entidadPension = ''
                vm.afiliado.modalidadPension = ''
            }
            vm.afiliado.idEstadoCivil = response.idEstadoCivil
            vm.afiliado.idSistemaSalud = response.idSistemaSalud            
            vm.afiliado.direccion = response.direccion.descripcion
            vm.afiliado.descripcionAdicional = response.direccion.descripcionAdicional
            vm.afiliado.idRegion = response.direccion.idRegion
            vm.afiliado.idComuna = response.direccion.idComuna
          
            if(vm.isAdmin && (response.tipoAfiliado=='PASIVO' || response.tipoAfiliado=='Pasivo')){
                vm.afiliado.deshabilitado = false
            }else{
                vm.afiliado.deshabilitado = true
            }
      
            vm.afiliado.estadoAfiliado = response.estadoAfiliado.toUpperCase();
            vm.afiliado.fechaDeshabilitada=false
            if(response.estadoAfiliado.toUpperCase()=='RECHAZAR_AFILIACION' || response.estadoAfiliado.toUpperCase()=='PENDIENTE_DESAFILIACION'){
                vm.afiliado.fechaDeshabilitada=true
            }
            if(vm.rol=='ROLE_AFILIADO'){
                vm.afiliado.fechaDeshabilitada=true
            }
            
              if(response.documentos){
                vm.afiliado.documentos = response.documentos
            } else {
                vm.afiliado.documentos = []
            }

            vm.afiliado.numero = response.direccion.numero
            vm.afiliado.descripcionAdicional = response.direccion.descripcionAdicional
            vm.afiliado.telefonoFijo = response.telefonoFijo
            vm.afiliado.telefonoMovil = response.telefonoMovil
            vm.afiliado.cargas = response.carga
            vm.afiliado.observacion = response.observacion
            vm.afiliado.isAdmin=vm.isAdmin
        } catch (e) {
            console.log('error::', e)
            return
        }
    }

    limpiarData() {
        let vm = this
        vm.afiliado = new Afiliado();
        this.afiliacionService.traeBancos().then
            (bancos => {
                vm.bancos = bancos
                vm.afiliado.bancos = vm.bancos
            })
        this.afiliacionService.traeTipoCuentas().then
            (tipoCuentas => {
                vm.tipoCuentas = tipoCuentas
                vm.afiliado.tipoCuentas = vm.tipoCuentas
            })

        this.afiliacionService.traeNacionalidades().then
            (nacionalidades => {
                vm.nacionalidades = nacionalidades
                vm.afiliado.nacionalidades = vm.nacionalidades
            })
        
        this.afiliacionService.getTipoPension().then
            (tiposPensiones => {
                vm.tiposPensiones = tiposPensiones
                vm.afiliado.tiposPensiones = vm.tiposPensiones
        })

        this.afiliacionService.getEntidadPension().then
        (entidadesPensiones => {
            vm.entidadesPensiones = entidadesPensiones
            vm.afiliado.entidadesPensiones = vm.entidadesPensiones
        })  
        
        this.afiliacionService.getModalidadPension().then
        (modalidadesPensiones => {
            vm.modalidadesPensiones = modalidadesPensiones
            vm.afiliado.modalidadesPensiones = vm.modalidadesPensiones
        }) 


        this.mantenedorUsuarioService.traeRegiones().then
            (regiones => { vm.afiliado.regiones = regiones })

                    this.afiliacionService.traeEstadoCivil().then
                    (estadoCivil => {
                        vm.estadoCivil = estadoCivil
                        vm.afiliado.estadoCivil = vm.estadoCivil
                    })
    
            this.afiliacionService.traeSistemaSalud().then
            (sistemaSalud => {
                vm.sistemaSalud = sistemaSalud
                vm.afiliado.sistemaSalud = vm.sistemaSalud
            })
    }




    buscarDesdeGesdep(rut: any) {
        var vm = this
        this.afiliacionService.validaAfiliadoPorRut(rut.split('-')[0],false).then
            (
                (sumatoriaCupoOcupado) => {
                    this.afiliacionService.traeAfiliadoGesdep(rut).then
                        (
                            (usuario: Usuario) => {
                                vm.data.email = usuario.correoElectronico
                                vm.data.nombres = usuario.nombres + ' ' + usuario.apellidoPaterno + ' ' + usuario.apellidoMaterno
                               
                                if (usuario.calidadJuridicaCodigo == 1 || usuario.calidadJuridicaCodigo == 4 || usuario.calidadJuridicaCodigo == 5) {
                                    Swal.fire({
                                        allowOutsideClick: false,
                                        icon: 'info',
                                        text: 'Cargando...'
                                    });
                                    Swal.showLoading();
                                    this.afiliacionService.actualizaAfiliadoDesdeGesdep(this.afiliado.rut).then
                                        (
                                            response => {
                                                console.log(response)
                                                this.buscar(true, false, 'Se ha actualizado correctamente el afiliado.')
                                            }
                                        )
                                        .catch
                                        (
                                            () => {
                                                vm.openAlertDialog('Ha surgido un error en la actualización.', 'btn-danger')
                                            }
                                        )
                                } else {

                                    const dialogRef = this.dialog.open(ConfirmationDialogEspecial, {
                                        data: {
                                            message: 'Calidad jurídica no cumple con requisito para cursar solicitud de afiliación ¿Esta seguro que quiere ingresar afiliación?'
                                            ,botonStyleCancel:"margin-left:20%;"
                                            ,botonStyleAceptar:"margin-left:20%;"
                                            , buttonText: { ok: 'Si', cancel: 'No' }
                                        }
                                    });

                                    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                                        if (confirmed) {
                                            Swal.fire({
                                                allowOutsideClick: false,
                                                icon: 'info',
                                                text: 'Cargando...'
                                            });
                                            Swal.showLoading();
                                            this.afiliacionService.actualizaAfiliadoDesdeGesdep(this.afiliado.rut).then
                                                (
                                                    response => {
                                                        console.log(response)
                                                        this.buscar(true, false,'Se ha actualizado correctamente el afiliado.')
                                                    }
                                                )
                                                .catch
                                                (
                                                    () => {
                                                        vm.openAlertDialog('Ha surgido un error en la actualización.', 'btn-danger')
                                                    }
                                                )
                                        }
                                    });
                                }
                            }
                        )
                        .catch
                        (
                            error => {
                                console.log(error)
                                Swal.close();
                                vm.openAlertDialog('RUT no existe en GESDEP.', 'btn-dark')
                                this.limpiarData();
                            }
                        )
                }
            )
            .catch
            (
                error => {
                    if (error.status == 406) {
                        this.openAlertDialog('El rut del usuario ya existe en BIENESTAR, favor contactarse con un ejecutivo.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 500) {
                        this.openAlertDialog(error.error.message, 'btn-danger')
                        Swal.close();
                    } else {
                        console.log(error)
                        this.openAlertDialog('Ocurrió un error al gestionar una solicitud de afiliación.', 'btn-danger')
                        Swal.close();
                    }
                }
            )
    }


    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }


    agregar() {
        let vm = this      
        this.limpiarData()
        vm.accion="guardar" 
        vm.entidad="creacion"      
    }

    guardar() {
    let vm = this      
    vm.accion="guardar" 
    let retornar= this.validarFormulario()
    
    if(!retornar){
        return false;
    }
    
    if (!vm.afiliado.rut.includes('-')) {
        this.openAlertDialog('Debe ingresar el campo rut con guión.', 'btn-dark')
        return false
    }
    
     
        if (Rut(vm.afiliado.rut)) {

            const dialogRef = this.dialog.open(ConfirmationDialog,
                {
                    data: { message: '¿Estás seguro de crear o actualizar el afiliado?', buttonText: { ok: 'Si', cancel: 'No' } }
                })
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        icon: 'info',
                        text: 'Cargando...'
                    });
                    Swal.showLoading();
                    this.afiliacionService.crearGuardarAfiliado(this.afiliado,vm.accion,vm.entidad).then
                        (
                            response => {
                                //vm.openAlertDialog('Se ha agregado o actualizado correctamente el afiliado Pensionado.', 'btn-success')
                                this.buscar(true, false,'Se ha agregado o actualizado correctamente el afiliado Pensionado.')
                          		Swal.close();
                              
                            }
                        )
                        .catch
                        (
                            (error) => {
                                console.log(error)
                                console.log(error.status)
                                console.log(error.message)
                                Swal.close();
                                if(error.status==500){
                                    vm.openAlertDialog('Usuario ya existe en la base', 'btn-danger')
                                }else{
                                    vm.openAlertDialog('Ha surgido un error en la actualización.', 'btn-danger')
                                }
                               
                            }
                        )
                }
            })

        } else {
            this.openAlertDialog('El RUT del usuario es incorrecto. Favor Revisar', 'btn-danger')
        }
     
    }

    
    
    validarFormulario(): boolean {
        var vm = this
        const emailPattern =/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
        let fechaAfiliacion = new Date(this.afiliado.fechaAfiliacion + 'T00:00')
        let fechaNacimiento = new Date(this.afiliado.fechaNacimiento + 'T00:00')
        let fechaactual = new Date()

        if(!vm.afiliado.rut){
            this.openAlertDialog('Debe ingresar el campo rut.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.nombres){
            this.openAlertDialog('Debe ingresar el campo nombres.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.apellidoPaterno){
            this.openAlertDialog('Debe ingresar el campo apellido Paterno.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.apellidoMaterno){
            this.openAlertDialog('Debe ingresar el campo apellido Materno.', 'btn-dark')
            return false
        }       
        if(!vm.afiliado.fechaNacimiento){
            this.openAlertDialog('Debe ingresar el campo fecha de Nacimiento.', 'btn-dark')
            return false
        }
        if (fechaNacimiento > fechaactual) {
            Swal.close();
            this.openAlertDialog('La fecha de Nacimiento no debe super la fecha actual. Favor revisar.', 'btn-dark')
            return false
        }        
        if(!vm.afiliado.idSistemaSalud){
            this.openAlertDialog('Debe ingresar el campo sistema salud.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.direccion){
            this.openAlertDialog('Debe ingresar el campo dirección.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.idRegion){
            this.openAlertDialog('Debe ingresar el campo región.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.numero){
            this.openAlertDialog('Debe ingresar el campo número de dirección.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.idComuna){
            this.openAlertDialog('Debe ingresar el campo comuna.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.telefonoFijo){
            this.openAlertDialog('Debe ingresar el campo telefono Fijo y validar que el campo solo contenga números.', 'btn-dark')
            return false
        }
        if (vm.afiliado.telefonoFijo &&  (vm.afiliado.telefonoFijo.length >9 || vm.afiliado.telefonoFijo.length <8)) {
            this.openAlertDialog('Debe ingresar número de teléfono entre 8 y 9 dígitos.', 'btn-dark')
            return false
        }
        if (vm.afiliado.telefonoMovil &&  (vm.afiliado.telefonoMovil.length >9 || vm.afiliado.telefonoMovil.length <8)) {
            this.openAlertDialog('Debe ingresar número de teléfono móvil entre 8 y 9 dígitos.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.email){
            this.openAlertDialog('Debe ingresar el campo email.', 'btn-dark')
            return false
        }
        if (!emailPattern.test(vm.afiliado.email)) {
            this.openAlertDialog('Debe ingresar un correo válido.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.entidadPension){
            this.openAlertDialog('Debe ingresar el campo entidad Pension.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.tipoPension){
            this.openAlertDialog('Debe ingresar el campo tipo Pension.', 'btn-dark')
            return false
        }
        if(!vm.afiliado.montoPension){
            this.openAlertDialog('Debe ingresar el campo monto Pensión y validar que el campo solo contenga números.', 'btn-dark')
            return false
        }
       
        if(vm.afiliado.montoPension && (vm.afiliado.montoPension.length) >8){
            this.openAlertDialog('El monto de pensión no debe superar los 8 dígitos.', 'btn-dark')
            return false
        }

        if(!vm.afiliado.tipoCuentaCodigo){
            this.openAlertDialog('Debe ingresar el campo Tipo de Cuenta.', 'btn-dark')
            return false
        }

        if(!vm.afiliado.bancoCodigo){
            this.openAlertDialog('Debe ingresar el campo Entidad Bancaria.', 'btn-dark')
            return false
        }

        if(!vm.afiliado.numeroCuenta){
            this.openAlertDialog('Debe ingresar el campo Número Cuenta y validar que el campo solo contenga números.', 'btn-dark')
            return false
        }

        if(!vm.afiliado.fechaAfiliacion){
            this.openAlertDialog('Debe ingresar la fecha de afiliación.', 'btn-dark')
            return false
        }     
        if (fechaAfiliacion > fechaactual) {
            Swal.close();
            this.openAlertDialog('La fecha de fechaAfiliacion no debe super la fecha actual. Favor revisar.', 'btn-dark')
            return false
          }   
        
        return true
    }

    

        
}
